import React from 'react'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import type { TenantThemeConfig } from '../../types/theme'
import './ModernLobbyHuayLayout.css'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

export interface LobbyHuayOutletContext {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

interface ModernLobbyHuayLayoutProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

const TABS = [
  { to: 'listall', label: 'แทงหวย', icon: 'fas fa-ticket-alt' },
  { to: 'set', label: 'เลขชุด', icon: 'fas fa-layer-group' },
  { to: 'slip', label: 'โพยหวย', icon: 'fas fa-receipt' },
  { to: 'result', label: 'ผลหวย', icon: 'fas fa-trophy' },
]

/** Layout หน้า lobby-huay: แท็บแนวนอน (แทงหวย, เลขชุด, โพยหวย, ผลหวย) + Outlet — ไม่แสดงแท็บเมื่ออยู่หน้า yeekee หรือ lottery-terms */
const ModernLobbyHuayLayout: React.FC<ModernLobbyHuayLayoutProps> = ({ themeConfig, assetConfig }) => {
  const location = useLocation()
  const hideTabs =
    location.pathname.includes('/yeekee') ||
    location.pathname.includes('/lottery-terms') ||
    location.pathname.includes('/bet') ||
    location.pathname.includes('/set-lotto-game')
  const isBetPage = location.pathname.includes('/bet')

  return (
    <div className={`content${isBetPage ? ' content-huay-bet' : ''}`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1">
            {!hideTabs && (
              <div
                className="lobby-huay-tabs nav nav-pills mb-3"
                id="v-pills-tab"
                role="tablist"
              >
                {TABS.map((tab) => (
                  <NavLink
                    key={tab.to}
                    to={tab.to}
                    end={tab.to === 'listall'}
                    className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                  >
                    <span className="lobby-huay-tabs__icon" aria-hidden="true">
                      <i className={tab.icon} />
                    </span>
                    <span className="lobby-huay-tabs__label">{tab.label}</span>
                  </NavLink>
                ))}
              </div>
            )}
            <Outlet context={{ themeConfig, assetConfig } satisfies LobbyHuayOutletContext} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModernLobbyHuayLayout
